var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDolar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.0723C23.5 23.134 22.0242 24.9128 18.9347 25.2362V27.5H17.3211V25.2564C15.3927 25.1351 13.5233 24.4883 12.5 23.5787L13.3855 21.5372C14.3497 22.3457 15.8256 22.9319 17.3211 23.0734V19.0309C15.1369 18.4851 12.7952 17.7574 12.7952 14.9479C12.7952 12.8862 14.2513 11.0872 17.3211 10.784V8.5H18.9347V10.7436C20.3909 10.8245 21.8667 11.2691 22.9293 11.9766L22.1225 14.0181C21.0796 13.3915 19.9776 13.0479 18.9347 12.9266V17.0096C21.119 17.5553 23.5 18.2628 23.5 21.0723ZM15.3336 14.8266C15.3336 15.7968 16.1798 16.2415 17.3211 16.5851V12.9872C15.924 13.2096 15.3336 13.9372 15.3336 14.8266ZM18.9347 23.033C20.3712 22.8106 20.9812 22.1234 20.9812 21.2543C20.9812 20.2638 20.1154 19.7989 18.9347 19.4553V23.033Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolar);
export default __webpack_public_path__ + "static/media/dolar.7ba4286e839e48d725fa48574adf03a9.svg";
export { ForwardRef as ReactComponent };